import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {fetchRecord} from '/redux/action/report.action';
import {
  hasReportRecordData,
  reportRecordData,
} from '/redux/selector/report.selector';

import ReportRecordDataProvider from './ReportRecordDataProvider';

export default connect(
  createStructuredSelector({
    hasReportRecordData,
    reportRecordData,
  }),
  dispatch => ({
    fetchReportRecord: ({
      recordsName,
      recordsParams,
      recordParams,
      recordExtras,
    }: any) =>
      dispatch(
        // @ts-expect-error TS(2345): Argument of type '{ (dispatch: any, getState: any)... Remove this comment to see the full error message
        fetchRecord({recordsName, recordsParams, recordParams, recordExtras}),
      ),
  }),
  (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    fetchReportRecord: () => {
      const {recordsName, recordsParams, recordParams, recordExtras} = ownProps;
      return dispatchProps.fetchReportRecord({
        recordsName,
        recordsParams,
        recordParams,
        recordExtras,
      });
    },
  }),
)(ReportRecordDataProvider);
